<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <search-channel-select
        v-model="tableParams.channelId"
        :channelType="100"
      />
      <el-select
        v-model="tableParams.isShow"
        clearable
        placeholder="展示状态"

        style="margin-right: 15px"
      >
        <el-option value="0" label="已展示"></el-option>
        <el-option value="1" label="未展示"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.settleWay"
        clearable
        placeholder="计费方式"

        style="margin-right: 15px"
      >
        <el-option value="1" label="CPM"></el-option>
        <el-option value="2" label="CPD"></el-option>
        <el-option value="3" label="CPA"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.isAccount"
        clearable
        placeholder="付款状态"

        style="margin-right: 15px"
      >
        <el-option value="0" label="已付款"></el-option>
        <el-option value="1" label="不通过"></el-option>
        <el-option value="2" label="待审核/审核中"></el-option>
        <el-option value="3" label="待提现/申请提现"></el-option>
      </el-select>
      <el-select
        v-model="tableParams.channelSubject"
        placeholder="请选择渠道主体"

        style="margin-right: 15px"
        clearable
      >
        <el-option
          v-for="item in channelSubjectList"
          :label="item.subjectName"
          :value="item.subjectId"
          :key="item.subjectId"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="date"
        @change="changeDate"
        style="margin-right: 15px"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始月份"
        end-placeholder="结束月份"
        :editable="false"
      >
      </el-date-picker>
      <el-button @click="toQuery" type="primary">搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="
            downExcel(
              '/reportCollect/collect/list/xlsx',
              '月度结算',
              tableParams
            )
          "
          type="warning"
          size="mini"
          style="margin-left: 10px"
        >下载
        </el-button
        >
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row
        :summary-method="tableSummary"
        show-summary
        size="small"
        ref="table"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
          :sortable="v.field === 'dateCreated' || v.field === 'reportDate'
          || v.field === 'alreadyShowSmt'
          || v.field === 'alreadyClkSmt'
          || v.field === 'alreadyExpenses'
          || v.field === 'awaitShowSmt'
          || v.field === 'awaitClkSmt'
          || v.field === 'waitExpenses'"
          align="center"
        >
          <template v-slot="scope">
            <div v-if="v.field === 'ticketUrls'">
              <div v-if="scope.row.ticketUrls">
                <span style="color: #409eff; cursor: pointer" @click="downbill(scope.row.ticketUrls)">下载</span>
              </div>
              <div v-else>-</div>
            </div>
            <span v-else-if="v.field === 'isShow'">
              <el-switch
                v-model="scope.row[v.field]"
                :disabled="scope.row.isShow == 0"
                @change="
                  (state) => {
                    handleAccountChange(state, scope.row);
                  }
                "
                :active-value="0"
                :inactive-value="1"
              />
            </span>
            <span v-else-if="v.field === 'isAccount'">{{
                AccountMap[scope.row[v.field]] || "-"
              }}</span>
            <span v-else-if="v.field === 'settleWay'">{{
                settleWayMap[scope.row[v.field]] || "-"
              }}</span>
            <div v-else-if="v.field === 'remark'">
              <el-button
                v-if="!scope.row[v.field]"
                size="mini"
                @click="upRemark(scope.row)"
              >添加
              </el-button
              >
              <span v-else @click="upRemark(scope.row)">{{
                  scope.row[v.field]
                }}</span>
            </div>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button
              @click="handleSetting(scope.row)"
              :disabled="!(scope.row.isShow == 0 && scope.row.isAccount == 2)"
              type="primary"
              size="mini"
            >审核
            </el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="下载明细" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button
              @click="
                downExcel(
                  '/reportCollect/detail/collect/list/xlsx',
                  '汇总明细报表',
                  { reportId: scope.row.reportId }
                )
              "
              :disabled="!scope.row.detailId"
              type="success"
              size="mini"
            >下载
            </el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="下载对账单" align="center" width="100">
          <template v-slot="scope" align="center">
            <el-button
              @click="
                downExcel(
                  '/reportCollect/media/collect/list/xlsx',
                  '对账单报表',
                  {
                    reportId: scope.row.reportId,
                    channelId: scope.row.channelId,
                  }
                )
              "
              :disabled="scope.row.isShow"
              type="success"
              size="mini"
            >下载对账单
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60, pagination.total]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
    <el-dialog
      v-model="dialogStatus"
      @close="sureClose"
      title="修改确定"
      :width="500"
      align="center"
      append-to-body
    >
      <div class="tip">确认修改展示状态吗？确认之后将无法撤回</div>
      <el-button @click="sureClose">取消</el-button>
      <el-button @click="sure" type="primary">提交</el-button>
    </el-dialog>

    <el-dialog
      v-model="dialogStatus3"
      @close="remarkClose"
      title="更改说明"
      :width="500"
      align="center"
      append-to-body
    >
      <el-input type="textarea" :rows="5" placeholder="说明" v-model="textarea">
      </el-input>
      <div style="margin: 20px 0; text-align: right">
        <el-button @click="remarkClose">取消</el-button>
        <el-button @click="sureRemark" type="primary"
        >提交
        </el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      v-model="dialogStatus2"
      @close="auditClose"
      title="付款审核"
      :width="500"
      align="center"
      append-to-body
    >
      <div style="margin: 20px 0">
        <el-radio v-model="radio" :label="0">已付款</el-radio>
        <el-radio v-model="radio" :label="1">不通过</el-radio>
      </div>
      <el-input type="textarea" :rows="5" placeholder="备注" v-model="textarea">
      </el-input>
      <div style="margin: 20px 0; text-align: right">
        <el-button @click="auditClose">关闭</el-button>
        <el-button
          @click="audit"
          type="primary"

          :disabled="!(radio === 0 || radio === 1)"
        >保存
        </el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SearchChannelSelect from '@/components/SearchChannelSelect'
import TableColumn from '@/components/TableColumn'
import {downExcelMixin} from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'
import {formatDate, SIMPLE_MONTH_PATTERN} from '@/util/format'

import {setStatus, auditing, setRemark} from '@/api/manage/account/monthly'
import {getChannelSubjectList} from '@/api/manage/channel/channel'

export default {
  name: 'Manage/account/monthly',
  components: {
    SearchChannelSelect,
    TableColumn
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        {field: 'dateCreated', title: '创建日期'},
        {field: 'reportDate', title: '月份'},
        {field: 'channelName', title: '渠道名称'},
        {field: 'subjectName', title: '渠道主体名称'},
        {field: 'alreadyShowSmt', title: '结算展示'},
        {field: 'alreadyClkSmt', title: '结算点击/下载'},
        {field: 'alreadyExpenses', title: '结算支出'},
        {field: 'awaitShowSmt', title: '待结算展示'},
        {field: 'awaitClkSmt', title: '待结算点击/下载'},
        {field: 'awaitExpenses', title: '待结算支出'},
        {field: 'ticketUrls', title: '发票'},
        {field: 'isShow', title: '展示状态'},
        {field: 'setShowName', title: '创建人'},
        {field: 'setShowTime', title: '创建时间'},
        {field: 'odd', title: '快递单号'},
        {field: 'isAccount', title: '付款状态'},
        {field: 'settleWay', title: '结算方式'},
        {field: 'remark', title: '说明'}
      ],
      AccountMap: {
        0: '已付款',
        1: '不通过',
        2: '待审核',
        3: '待提现'
      },
      showMap: {
        1: '未展示',
        0: '已展示'
      },
      settleWayMap: {
        1: 'CPM',
        2: 'CPD',
        3: 'CPA'
      },
      date: [new Date(), new Date()],
      dialogStatus: false,
      dialogStatus2: false,
      dialogStatus3: false,
      auditData: {},
      statusData: {},
      radio: undefined,
      textarea: undefined,
      remarkId: undefined,
      channelSubjectList: []
    }
  },
  created() {
    this.date[0].setMonth(new Date().getMonth(), 0)
    this.date[1].setMonth(new Date().getMonth(), 0)
    this.changeDate(this.date)
    getChannelSubjectList()
      .then(res => {
        this.channelSubjectList = res.data
      })
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit() {
      this.tableUrl = '/reportCollect/collect/list'
      return true
    },
    changeDate(date) {
      this.tableParams.startTime = date[0] ? formatDate(date[0], SIMPLE_MONTH_PATTERN) : date[0]
      this.tableParams.endTime = date[1] ? formatDate(date[1], SIMPLE_MONTH_PATTERN) : date[1]
    },
    sureClose() {
      this.statusData = {},
        this.dialogStatus = false
      this.init()
    },
    sure() {
      setStatus(this.statusData).then(res => {
        if (res.code === 200) {
          this.$message.success('修改展示状态成功')
          this.dialogStatus = false
        }
      }).catch(() => {
        this.$message.error('修改展示状态失败')
        this.dialogStatus = false
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].reportId === this.statusData.reportId) {
            this.tableData[i].reportId = this.tableData[i].reportId ? 0 : 1
            return
          }
        }
      })
    },
    handleAccountChange(state, row) {
      if (!row.reportId) {
        return
      }
      this.dialogStatus = true
      this.statusData = {
        reportId: row.reportId,
        isShow: state
      }
    },
    upRemark(row) {
      this.dialogStatus3 = true
      this.textarea = row.remark
      this.remarkId = row.reportId
    },
    remarkClose() {
      this.dialogStatus3 = false
      this.textarea = ''
      this.remarkId = undefined
    },
    sureRemark() {
      setRemark({reportId: this.remarkId, remark: this.textarea}).then(res => {
        if (res.code === 200) {
          this.remarkClose()
          this.init()
        }
      }).catch(() => {
        this.$message.error('修改说明失败')
        this.remarkClose()
      })
    },
    handleSetting(row) {
      this.dialogStatus2 = true
      this.textarea = row.remark
      this.auditData = {
        reportId: row.reportId,
        isAccount: row.isAccount,
        remark: row.remark
      }
    },
    audit() {
      this.auditData.isAccount = this.radio
      this.auditData.remark = this.textarea
      auditing(this.auditData).then(res => {
        if (res.code === 200) {
          this.dialogStatus2 = false
          this.init()
        }
      }).catch(() => {
        this.$message.error('付款审核失败')
        this.dialogStatus2 = false
      })
    },
    auditClose() {
      this.auditData = {}
      this.radio = undefined
      this.textarea = undefined
      this.dialogStatus2 = false
    },
    async downbill(data) {
      for (const url of data) {
        try {
          const response = await fetch(this.$imgURL + url);
          const blob = await response.blob();
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = url.split('/').pop(); // 获取文件名
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(downloadUrl);
          document.body.removeChild(a);
        } catch (e) {
          conthis.$message.error(`下载失败: ${url}`, error);
        }
      }
    },
    tableSummary(row) {
      const arr = ['alreadyShowSmt', 'alreadyClkSmt', 'alreadyExpenses', 'awaitShowSmt', 'awaitClkSmt', 'awaitExpenses']
      const fixedArr = ['alreadyExpenses', 'awaitExpenses']
      const {data} = row
      const checklists = this.checkColumns.map(item => {
        return item.field
      })
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            out[i] = arr.indexOf(checklists[i]) > -1 ? (data.reduce((total, item) => {
              return total + Number(item[checklists[i]])
            }, 0)).toFixed(2) : '-'
          } else {
            out[i] = arr.indexOf(checklists[i]) > -1 ? data.reduce((total, item) => {
              return total + Number(item[checklists[i]])
            }, 0) : '-'
          }
        }
      }
      return out
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}

.form-label {
  display: block;
  line-height: 20px;
}

.form-item__label {
  line-height: 20px;
}

.tip {
  color: red;
  text-align: center;
  margin-bottom: 20px;
}
</style>
